import MaxWidthContainer from 'components/MaxWidthContainer';
import Link from 'next/link';
import useSWR from 'swr';
import { swrFetcher } from 'utils/api';

const HomeLandingInfo = () => {
  const {
    data: articlesData,
    error,
    isLoading,
  } = useSWR('/api/v4/landing-pages?page_size=4', swrFetcher);

  const articles = articlesData?.data || [];

  const displayArticles = articles;

  if (isLoading) {
    return (
      <div className="my-6 lg:my-12">
        <MaxWidthContainer className="px-4 lg:px-0">
          <div className="mb-6 flex items-center justify-between">
            <h2 className="text-xl font-bold text-[#111928] lg:text-2xl">
              美妝情報
            </h2>
            <div className="h-6 w-16 animate-pulse rounded bg-gray-200"></div>
          </div>

          <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-6">
            {Array.from({ length: 4 }, (_, i) => (
              <div key={i} className="animate-pulse">
                <div className="aspect-square rounded-lg bg-gray-200"></div>
                <div className="mt-3 space-y-2">
                  <div className="h-4 w-16 rounded bg-gray-200"></div>
                  <div className="h-4 w-full rounded bg-gray-200"></div>
                  <div className="h-4 w-4/5 rounded bg-gray-200"></div>
                </div>
              </div>
            ))}
          </div>
        </MaxWidthContainer>
      </div>
    );
  }

  if (!displayArticles.length) return null;

  return (
    <div className="my-6 lg:my-12">
      <MaxWidthContainer className="px-4 lg:px-0">
        <div className="mb-6 flex items-center justify-between">
          <h2 className="text-xl font-bold text-[#111928] lg:text-2xl">
            美妝情報
          </h2>
        </div>

        {/* 文章卡片網格 */}
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-6">
          {displayArticles.map((article) => (
            <Link
              key={article.id}
              href={`/landing/${article.slug}`}
              className="group block overflow-hidden rounded-lg bg-white transition-all"
            >
              {/* 文章主圖 */}
              <div className="h-[161px] w-[161px] overflow-hidden rounded-xl border border-gray-200 lg:h-[302px] lg:w-[302px]">
                <img
                  src={
                    article.image?.formats?.small?.url ||
                    article.image?.url ||
                    '/images/placeholders/article.png'
                  }
                  alt={article.title}
                  className="h-full w-full object-cover transition-transform"
                />
              </div>

              {/* 內容區域 */}
              <div className="py-2 lg:py-2">
                {/* 分類標籤 */}
                {article.tags && article.tags.length > 0 && (
                  <div className="mb-2 flex flex-wrap gap-1">
                    {article.tags.slice(0, 2).map((tag, index) => (
                      <span
                        key={index}
                        className="inline-block rounded-md bg-sorra-pink/10 px-2 py-1 text-[12px] font-medium text-sorra-pink"
                      >
                        {tag}
                      </span>
                    ))}
                    {article.tags.length > 2 && (
                      <span className="inline-block rounded-md bg-gray-100 px-2 py-1 text-[12px] font-medium text-gray-600">
                        +{article.tags.length - 2}
                      </span>
                    )}
                  </div>
                )}
                {/* 文章標題 */}
                <h3 className="line-clamp-2 text-sm font-bold text-gray-900 lg:text-base">
                  {article.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>

        <div className="p-none flex items-center justify-center pt-[32px] lg:p-4">
          <Link
            href="/landing"
            className="block w-full rounded-lg border border-sorra-pink px-5 py-2.5 text-center text-sm font-medium text-sorra-pink focus:outline-none focus:ring-4 focus:ring-blue-300 xl:w-[360px]"
          >
            查看全部
          </Link>
        </div>
      </MaxWidthContainer>
    </div>
  );
};

export default HomeLandingInfo;
